import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const destroyContact = async (uuid: string) => {
  const response = await CustomAxios.delete(`contacts/${uuid}`);
  const { data } = response;
  return data;
};
interface UseDestroyContactFormProps {
  uuid: string;
  onSuccessCallback: () => void;
}
export function useDestroyContact({ uuid, onSuccessCallback }: UseDestroyContactFormProps) {
  return useMutation({
    mutationFn: () => destroyContact(uuid),
    onSuccess: () => {
      // fetch the contact again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allContacts, uuid] });

      // call success
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to delete the contact. Please try again and contact support if the problem persists.');
      }
    },
  });
}
